/**
 * A-26 — the editable Made cell of the production table, as pure rules so they are tested without a screen.
 * Made is typed as a number; the Job Numbers are generated by the server. It can only go up.
 */
export interface ProductionLine {
  id: string;
  ordered: number;
  made: number;
}

export interface Draft { made: string }

export const draftOf = (l: ProductionLine): Draft => ({ made: String(l.made) });

const madeOf = (d: Draft): number => (/^\d+$/.test(d.made.trim()) ? Number(d.made.trim()) : NaN);

/** Has this row been changed from what is saved? */
export function isDirty(l: ProductionLine, d: Draft): boolean {
  return madeOf(d) !== l.made;
}

/** Why this row cannot be saved as it stands, in plain words, or null. */
export function problemWith(l: ProductionLine, d: Draft): string | null {
  const made = madeOf(d);
  if (Number.isNaN(made)) return 'Made must be a whole number.';
  if (made < l.made) return `${l.made} already made and recorded; it cannot be lowered here.`;
  if (made > l.ordered) return `Only ${l.ordered} were ordered.`;
  return null;
}

export interface SaveLine { orderLineId: string; made: number }

/** Only the changed rows, in the shape the API takes; null when nothing changed. */
export function buildSave(lines: readonly ProductionLine[], drafts: Readonly<Record<string, Draft>>): SaveLine[] | null {
  const out: SaveLine[] = [];
  for (const l of lines) {
    const d = drafts[l.id];
    if (!d || !isDirty(l, d)) continue;
    out.push({ orderLineId: l.id, made: madeOf(d) });
  }
  return out.length ? out : null;
}
